import gql from 'graphql-tag';

const GET_SALESFORCE_ACCOUNT_NAME_DIRECT = gql`
  query GetSalesforceAccountName($salesforceAccountId: String!) {
    getSalesforceAccountName(salesforceAccountId: $salesforceAccountId)
  }
`;

export default GET_SALESFORCE_ACCOUNT_NAME_DIRECT;
